import React from "react";
import { Column, Table, SortDirection, AutoSizer } from "react-virtualized";
import "react-virtualized/styles.css";
import styles from "./style.module.css";

import numeral from "numeral";

// key: dataKey, label

const labelData = [
  { dataKey: "BusinessImpact", label: "Business Impact" },
  { dataKey: "accuracy", label: "Accuracy" },
  { dataKey: "precision", label: "Precision" },
  { dataKey: "recall", label: "Recall" },
  { dataKey: "auc", label: "AUC" },
  { dataKey: "roc_auc_score", label: "ROC - AUC Score" },
  { dataKey: "f1_score", label: "F1 Score" },
  { dataKey: "hamming_loss", label: "Hamming Loss" },
  { dataKey: "hinge_loss", label: "Hinge Loss" },
  { dataKey: "log_loss", label: "Log Loss" },
  { dataKey: "threshold", label: "Threshold" },
  { dataKey: "MCC", label: "MCC" },
  { dataKey: "allPositives", label: "Total Positive Counts" },
  { dataKey: "totalCost", label: "Total Cost" },
  { dataKey: "mean_absolute_error", label: "Mean Absolute Error" },
  {
    dataKey: "mean_absolute_percentage_error",
    label: "Mean Absolute Percentage Error"
  },
  { dataKey: "mean_squared_error", label: "Mean Squared Error" },
  { dataKey: "r2_score", label: "R-Squared" },
  { dataKey: "sum_over_predict", label: "Sum Over Predict" },
  { dataKey: "sum_under_predict", label: "Sum Under Predict" },
  { dataKey: "count_over_predict", label: "Count Over Predict" },
  { dataKey: "count_under_predict", label: "Count Under Predict" },
  { dataKey: "revenue", label: "Success" },
  { dataKey: "cost", label: "Cost" },
  { dataKey: "tp", label: "True Positives" },
  { dataKey: "fp", label: "False Positives" },
  { dataKey: "tn", label: "True Negatives" },
  { dataKey: "fn", label: "False Negatives" }
];

class CheckboxClicker extends React.Component {
  constructor(props) {
    super(props);
    const { setLabels } = this.props;

    this.state = {
      BusinessImpact: "on",
      accuracy_score: "on",
      precision_score: "on",
      recall_score: "on",
      auc: "on",
      f1_score: "on",
      log_loss: "on"
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    for (let item of Object.keys(this.state)) {
      setLabels(item);
    }
  }

  handleInputChange(event) {
    const { setLabels } = this.props;

    const target = event.target;
    const value = target.checked ? target.value : target.checked;
    const name = target.name;

    setLabels(name);

    this.setState({
      [name]: value
    });
  }

  render() {
    return (
      <div className={styles.selectionHolder}>
        {labelData.map((i) => {
          return (
            <div key={i.label} className={styles.checkBoxHolder}>
              {i.label}
              <input
                className={styles.checkBox}
                name={i.dataKey}
                type="checkbox"
                checked={this.state[i.dataKey] == "on" ? true : false}
                onChange={this.handleInputChange}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

function screenWidth() {
  return window.innerWidth - 85;
}

function getMaxValues(models) {
  //for each non string key in models, grab the relative max
  //all models will have the same keys, so first we grab the keys from the zeroth model
  //if a key holds string data/ is null, then we ignore it
  //else, we look at each model and remember the largest value, and store it after the iteration
  let retModels = {};
  const modelKeys = Object.keys(models[0]);
  for (let modelKey of modelKeys) {
    if (!(Array.isArray(models[0][modelKey]) || typeof models[0][modelKey] == "object" || isNaN(models[0][modelKey]))) {
      let currentVal = 0;
      for (let model of models) {
        currentVal = Number(model[modelKey]) > currentVal ? Number(model[modelKey]) : currentVal;
      }
      retModels[modelKey] = currentVal;
    }
  }
  return retModels;
}

export class MetaDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    const { fids } = props;
    const { isContinuous } = this.props;

    const classLabels = [
      "BusinessImpact",
      "allPositives",
      "threshold",
      "accuracy",
      "precision",
      "recall",
      "auc",
      "f1_score",
      "log_loss",
      "MCC",
      "revenue",
      "cost",
      "tp",
      "fp",
      "tn",
      "fn"
    ];

    const contLabels = [
      "totalCost",
      "mean_absolute_error",
      "mean_squared_error",
      "r2_score",
      "sum_over_predict",
      "sum_under_predict",
      "count_over_predict",
      "count_under_predict"
    ];

    this.state = {
      width: screenWidth(),
      models: this.prepModels(props.models, fids, props.isContinuous),
      selectedLabels: isContinuous ? contLabels : classLabels,
      sortBy: "label",
      sortDirection: SortDirection.ASC
    };
  }

  prepModels(models, fids, isContinuous) {
    const { setup, unitRevenue } = this.props;
    let returnModels = [];
    let tempObj = {};

    const locale = navigator.language;

    for (let datum of models) {
      if (!datum?.isPlaceholder) {
        if (isContinuous) {
          tempObj.sum_over_predict = Number(datum?.metrics?.sum_over_predict?.toFixed(2)).toLocaleString(locale);
          tempObj.sum_under_predict = Number(datum?.metrics?.sum_under_predict?.toFixed(2)).toLocaleString(locale);
          tempObj.count_over_predict = Number(datum?.metrics?.count_over_predict?.toFixed(2)).toLocaleString(locale);
          tempObj.count_under_predict = Number(datum?.metrics?.count_under_predict?.toFixed(2)).toLocaleString(locale);
          tempObj.totalCost = Number(Math.abs(datum?.checkMax)).toLocaleString(locale);
          tempObj.mean_absolute_error = Number(datum?.metadata?.mean_absolute_error?.toFixed(5)).toLocaleString(locale);
          tempObj.mean_squared_error = Number(datum?.metadata?.mean_squared_error?.toFixed(5)).toLocaleString(locale);
          tempObj.r2_score = Number(datum.metadata?.r2_score?.toFixed(5)).toLocaleString(locale);
        } else {
          tempObj.accuracy = Number(datum?.maxIteration?.accuracy?.toFixed(5)).toLocaleString(locale);
          tempObj.precision = Number(datum?.maxIteration?.precision?.toFixed(5)).toLocaleString(locale);
          tempObj.recall = Number(datum?.maxIteration?.recall?.toFixed(5)).toLocaleString(locale);
          tempObj.MCC = Number(
            datum?.maxIteration?.confusionMatrix?.getMatthewsCorrelationCoefficient()?.toFixed(5)
          ).toLocaleString(locale);
          tempObj.threshold = Number(datum?.maxIteration?.confusionMatrix?.threshold).toString();
          tempObj.tp = Math.round(
            Number(datum?.maxIteration?.confusionMatrix?.tp ?? datum?.maxIteration?.truePositive)
          ).toLocaleString(locale);
          tempObj.fp = Math.round(
            Number(datum?.maxIteration?.confusionMatrix?.fp ?? datum?.maxIteration?.falsePositive)
          ).toLocaleString(locale);
          tempObj.fn = Math.round(
            Number(datum?.maxIteration?.confusionMatrix?.fn ?? datum?.maxIteration?.falseNegative)
          ).toLocaleString(locale);
          tempObj.tn = Math.round(
            Number(datum?.maxIteration?.confusionMatrix?.tn ?? datum?.maxIteration?.trueNegative)
          ).toLocaleString(locale);
          tempObj.allPositives = Math.round(
            Number(datum?.maxIteration?.confusionMatrix?.getAllPositive())
          ).toLocaleString(locale);
          tempObj.auc = Number(datum?.metadata?.auc?.toFixed(5)).toLocaleString(locale);
          tempObj.f1_score = Number(datum?.maxIteration?.confusionMatrix?.getF1Score().toFixed(5)).toLocaleString(
            locale
          );
          tempObj.log_loss = Number(datum?.metadata?.log_loss?.toFixed(5)).toLocaleString(locale);
          if (setup) {
            tempObj.BusinessImpact = Number(datum?.checkMax).toLocaleString(locale);
            const uRevenue = isNaN(unitRevenue)
              ? Number(setup.conversionGain) + Math.abs(Number(setup.conversionCost))
              : unitRevenue;
            tempObj.revenue = numeral(Number(datum?.maxIteration?.totalWins) * uRevenue).format("0.0a");
            tempObj.cost = numeral(
              Math.abs(
                (Number(datum?.maxIteration?.truePositive) + Number(datum?.maxIteration?.falsePositive)) *
                  Number(setup.conversionCost)
              )
            ).format("0.0a");
          } else {
            tempObj.BusinessImpact =
              datum.maxIteration && !isNaN(datum?.maxIteration?.roi)
                ? Number(datum?.maxIteration?.roi)?.toLocaleString(locale)
                : Number(datum?.checkMax)?.toLocaleString(locale);
            tempObj.revenue = numeral(datum?.maxIteration?.revenue).format("0.0a");
            tempObj.cost = numeral(Math.abs(datum?.maxIteration?.cost)).format("0.0a");
          }
        }
      }

      tempObj.id = datum.id;
      tempObj.isFrontier = fids.has(datum.id) ? "FRONTIER" : "";
      if (tempObj.isFrontier === "" && datum.id.includes("external-classifier-")) {
        tempObj.isFrontier = "EXTERNAL";
      }
      tempObj.label = datum.label;
      returnModels.push(tempObj);
      tempObj = {};
    }

    return returnModels;
  }

  componentDidMount() {
    window.addEventListener("resize", () => this.setScreenWidth());
  }

  setScreenWidth() {
    return this.setState({ width: screenWidth() });
  }

  headerRowRenderer = ({ className, columns, width, style }) => {
    return (
      <div className={styles.headerRow} style={{ width: width - 15 }} role="row">
        {columns}
      </div>
    );
  };

  setLabels(data) {
    let labels = this.state.selectedLabels;
    if (labels.includes(data)) {
      labels.splice(labels.indexOf(data), 1);
      return this.setState({ selectedLabels: labels });
    }
    labels.push(data);
    return this.setState({ selectedLabels: labels });
  }

  _sort({ sortBy, sortDirection }) {
    this.setState({ sortBy, sortDirection });
  }

  defaultHeaderRendererName(cellData) {
    const { ignoredModels, updateIgnoredModel, setIsAllowedInFrontier, updateChooseModel, models } = this.props;

    let isIgnored = false;

    if (!cellData) {
      return <div />;
    }

    if (cellData.dataKey === "label") {
      isIgnored = Object.keys(ignoredModels ?? {}).length !== 0;
    }

    return (
      <div className={styles.headerCell}>
        {cellData.dataKey === "label" && (
          <input
            type="checkbox"
            style={{ margin: "3px 5px 0px 0px" }}
            checked={isIgnored === true ? false : true}
            onClick={(e) => {
              e.stopPropagation();
              updateIgnoredModel(
                models.map((m) => m.id),
                !isIgnored
              );
              setIsAllowedInFrontier(
                models.map((m) => m.id),
                isIgnored
              );
            }}
          />
        )}
        <div>{String(cellData.label)}</div>
        {cellData.sortBy === cellData.dataKey && (
          <div style={{ width: "24px", textAlign: "center" }}>
            {cellData.sortDirection === "DESC" ? (
              <svg
                className="ReactVirtualized__Table__sortableHeaderIcon ReactVirtualized__Table__sortableHeaderIcon--DESC"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M7 10l5 5 5-5z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
              </svg>
            ) : (
              <svg
                className="ReactVirtualized__Table__sortableHeaderIcon ReactVirtualized__Table__sortableHeaderIcon--ASC"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path d="M7 14l5-5 5 5z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
              </svg>
            )}
          </div>
        )}
      </div>
    );
  }

  defaultCellRendererName(cellData) {
    const { ignoredModels, updateIgnoredModel, setIsAllowedInFrontier, updateChooseModel } = this.props;

    const isIgnored = ignoredModels[cellData.rowData.id];

    return (
      <div
        onClick={(e) => {
          e.stopPropagation();
          updateIgnoredModel(cellData.rowData.id, !isIgnored);
          setIsAllowedInFrontier(cellData.rowData.id, isIgnored);
        }}
        className={styles.nameCell}
      >
        <input
          type="checkbox"
          style={{ margin: "0px", marginRight: "5px" }}
          checked={isIgnored === true ? false : true}
          readOnly
        />
        <div>{String(cellData.cellData)}</div>
      </div>
    );
  }

  defaultCellRenderer(cellData) {
    if (cellData.cellData == "") {
      return "";
    } else {
      return <div className={styles.frontierModel}>{String(cellData.cellData)}</div>;
    }
  }

  boldData(cellData, maxes) {
    const keyCheck = String(cellData.dataKey);
    function parseNumber(value, locales = navigator.languages) {
      const example = Intl.NumberFormat(locales).format("1.1");
      const cleanPattern = new RegExp(`[^-+0-9${example.charAt(1)}]`, "g");
      const cleaned = value.replace(cleanPattern, "");
      const normalized = cleaned.replace(example.charAt(1), ".");

      return parseFloat(normalized);
    }

    if (cellData.cellData === undefined) {
      return <div />;
    }

    if (maxes[keyCheck] == Number(parseNumber(cellData.cellData))) {
      return <strong>{String(cellData.cellData)}</strong>;
    } else {
      return String(cellData.cellData);
    }
  }

  displayData(maxes, width) {
    const { netImpactLabel, limitColumns, optimized } = this.props;
    const { selectedLabels } = this.state;
    const maxLength = limitColumns !== undefined ? limitColumns : selectedLabels.length + 2;

    let retvalue = [
      <Column
        key="Model Name"
        label="Model Name"
        dataKey="label"
        width={200}
        cellRenderer={this.defaultCellRendererName.bind(this)}
        headerRenderer={this.defaultHeaderRendererName.bind(this)}
      />
    ];
    retvalue.push(
      <Column
        cellRenderer={this.defaultCellRenderer}
        key="isFrontier"
        label="Is Frontier?"
        dataKey="isFrontier"
        width={110}
      />
    );
    selectedLabels.forEach((datakey, i) => {
      if (limitColumns === undefined || i < limitColumns - 2) {
        //if datakey is business impact, I need to use a different label in my push
        const labeldat = labelData.find((obj) => {
          return obj.dataKey == datakey;
        });
        let labelString = labeldat.label;
        if (datakey == "BusinessImpact") {
          labelString = netImpactLabel;
        }
        if (datakey === "revenue" && optimized && optimized.revenueLabel) {
          labelString = optimized.revenueLabel;
        }
        if (datakey === "cost" && optimized && optimized.resourcingLabel) {
          labelString = optimized.resourcingLabel;
        }
        retvalue.push(
          <Column
            cellRenderer={(cellData) => this.boldData(cellData, maxes)}
            key={labeldat.label}
            label={labelString}
            dataKey={datakey}
            width={width / maxLength}
          />
        );
      }
    });
    return retvalue;
  }

  handleSelectModel(models, index) {
    const { updateChooseModel, model } = this.props;

    if (model?.id === models[index].id) {
      updateChooseModel(undefined);
    } else {
      updateChooseModel(models[index].id);
    }
  }

  rowStyleFormat(row, sortedModels) {
    const { model } = this.props;

    if (row.index < 0) return;
    if (model.id == sortedModels[row.index].id) {
      return {
        backgroundColor: "#E6E6FC",
        color: "#333",
        width: "100%",
        borderBottom: "1px solid #C8CAD4"
      };
    }
    return {
      width: "100%",
      borderBottom: "1px solid #C8CAD4",
      backgroundColor: "#FFFFFF"
    };
  }

  render() {
    const { models, fids, isContinuous, ignoredModels } = this.props;
    const { sortBy, sortDirection } = this.state;

    //log loss column should bold the smallest one
    //I am editing it after the fact so as to reuse the existing methodology
    //the numbers in pModels are strings so they need to be parsed and they have comma separators
    function parseNumber(value, locales = navigator.languages) {
      if (value === undefined || value === null) {
        return sortDirection === "DESC" ? -Infinity : Infinity;
      }

      const example = Intl.NumberFormat(locales).format("1.1");
      const cleanPattern = new RegExp(`[^-+0-9${example.charAt(1)}]`, "g");
      const cleaned = value.replace(cleanPattern, "");
      const normalized = cleaned.replace(example.charAt(1), ".");

      if (isNaN(normalized)) {
        return String(value);
      }

      return parseFloat(normalized);
    }

    let comparator = (a, b) => {
      let retA = a?.[sortBy];
      let retB = b?.[sortBy];
      if (sortBy !== "label" && sortBy !== "isFrontier") {
        retA = parseNumber(a[sortBy]);
        retB = parseNumber(b[sortBy]);
      }

      if (retA < retB) {
        return -1;
      }
      if (retA > retB) {
        return 1;
      }
      return 0;
    };

    // getNumericComparator((a) => parseNumber(a[sortBy]));

    let pModels = this.prepModels(models, fids, isContinuous);
    let sortedModels = pModels.sort(comparator);
    const maxes = getMaxValues(pModels);

    if (isContinuous) {
      maxes.totalCost = Math.min(
        ...pModels.map((value) => Number(value.totalCost ? parseNumber(value.totalCost) : null))
      );
      maxes.mean_absolute_error = Math.min(
        ...pModels.map((value) => Number(value.mean_absolute_error ? parseNumber(value.mean_absolute_error) : null))
      );
      maxes.mean_squared_error = Math.min(
        ...pModels.map((value) => Number(value.mean_squared_error ? parseNumber(value.mean_squared_error) : null))
      );
      maxes.r2_score = Math.max(...pModels.map((value) => Number(value.r2_score ? parseNumber(value.r2_score) : null)));
      maxes.sum_over_predict = Math.min(
        ...pModels.map((value) => Number(value.sum_over_predict ? parseNumber(value.sum_over_predict) : null))
      );
      maxes.sum_under_predict = Math.min(
        ...pModels.map((value) => Number(value.sum_under_predict ? parseNumber(value.sum_under_predict) : null))
      );
      maxes.count_over_predict = Math.min(
        ...pModels.map((value) => Number(value.count_over_predict ? parseNumber(value.count_over_predict) : null))
      );
      maxes.count_under_predict = Math.min(
        ...pModels.map((value) => Number(value.count_under_predict ? parseNumber(value.count_under_predict) : null))
      );
    } else {
      const logLossValues = pModels.map((value) => Number(value.log_loss ? parseNumber(value.log_loss) : null));
      const logLossMin = Math.min(...logLossValues);

      if (logLossMin !== undefined && !isNaN(logLossMin)) {
        maxes.log_loss = logLossMin;
      }
    }

    if (sortDirection == "DESC") {
      sortedModels = sortedModels.reverse();
    }
    const width = 1600;

    return (
      <React.Fragment>
        {/* <CheckboxClicker setLabels={() => this.setLabels()}/> */}
        <AutoSizer>
          {({ height }) => (
            <React.Fragment>
              {models?.length > 0 && models?.length === Object.keys(ignoredModels ?? {})?.length && (
                <NoModelsWarning models={models} ignoredModels={ignoredModels} />
              )}
              <Table
                width={width}
                height={height}
                headerHeight={50}
                headerClassName={styles.headerRow}
                headerRowRenderer={(args) => this.headerRowRenderer({ ...args, width: width })}
                containerStyle={{
                  width: width,
                  maxWidth: "100%"
                }}
                onRowClick={({ index }) => this.handleSelectModel(sortedModels, index)}
                rowHeight={50}
                rowCount={models.length}
                rowGetter={({ index }) => sortedModels[index]}
                rowStyle={(row) => this.rowStyleFormat(row, sortedModels)}
                sort={(sortBy, sortDirection) => this._sort(sortBy, sortDirection)}
                sortBy={sortBy}
                sortDirection={sortDirection}
              >
                {this.displayData(maxes, width)}
              </Table>
            </React.Fragment>
          )}
        </AutoSizer>
      </React.Fragment>
    );
  }
}

class NoModelsWarning extends React.PureComponent {
  render() {
    const { models, ignoredModels } = this.props;
    return (
      <div className={styles.modelsWarningWrapper}>
        <div className={styles.modelsWarningHeader}>{"No Models Enabled"}</div>
        <div className={styles.modelsWarningBody}>
          {`You've disabled all ${models.length} models for this AI. Please enable at least one model.`}
        </div>
      </div>
    );
  }
}

export default MetaDataTable;
